import { GzRmApplicationsSeverityWidgetWebComponent } from './component/GzRmApplicationsSeverityWidgetWebComponent';

export { GzRmApplicationsSeverityWidgetWebComponent };
